import { ref, firebaseAuth } from '../config/constants'
import { auth2 } from '../config/firebase2'

export function auth (email, pw) {
  return firebaseAuth().createUserWithEmailAndPassword(email, pw)
    .then(saveUser)
}

export function login (email, pw) {
  return firebaseAuth().signInWithEmailAndPassword(email, pw)
}

export function resetPassword (email) {
  return firebaseAuth().sendPasswordResetEmail(email)
}

export function saveUser (user) {
  return ref.child(`users/${user.uid}`)
    .set({
      email: user.email,
      uid: user.uid
    })
    .then(() => user)
}
// Log Out the Newly created User
export function logoutUser2 () { 
  auth2.onAuthStateChanged(function (present) {
    if (present) {
        auth2.signOut()
     }
    });
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js